export const timelineLabels = {
  INDENT_CREATED: 'indent_created',
  VEHICLE_REQUIREMENT_DATE: 'vehicle_requirement_date',
  VEHICLE_ASSIGNED: 'vehicle_assigned',
  ARRIVAL_SLA_BREACHED: 'arrival_sla_breached',
  REPORTED: 'reported',
  SOURCE_ARRIVED: 'source_arrived',
  SOURCE_DISPATCHED: 'source_dispatched',
  DESTINATION_REPORTED: 'destination_reported',
  DESTINATION_RELEASED: 'destination_reached',
  DELIVERED: 'delivered',
  READY_FOR_BILLING: 'ready_for_billing',
  INVOICE_GENERATED: 'invoice_generated',
  INVOICE_CHECKED: 'invoice_checked',
  INVOICE_RE_SUBMITTED: 'invoice_re_submitted',
  INVOICE_APPROVED: 'invoice_approved',
  INVOICE_REJECTED: 'invoice_rejected',
  INVOICE_RETURN: 'invoice_return',
  INVOICE_POSTED: 'invoice_posted',
  INVOICE_ON_HOLD: 'invoice_on_hold',
  INVOICE_PAID: 'invoice_paid',
  INVOICE_CANCELLED: 'invoice_cancelled',
  PAYMENT_REMOVED: 'payment_removed',
};

export const timelineToShowUsers = [
  timelineLabels.INVOICE_GENERATED,
  timelineLabels.INVOICE_CHECKED,
  timelineLabels.INVOICE_RE_SUBMITTED,
  timelineLabels.INVOICE_APPROVED,
  timelineLabels.INVOICE_REJECTED,
  timelineLabels.INVOICE_RETURN,
  timelineLabels.INVOICE_POSTED,
  timelineLabels.INVOICE_ON_HOLD,
  timelineLabels.INVOICE_PAID,
  timelineLabels.INVOICE_CANCELLED,
  timelineLabels.PAYMENT_REMOVED,
];
